import { render, staticRenderFns } from "./SendOrderToolbar.vue?vue&type=template&id=16f6158e&"
import script from "./SendOrderToolbar.vue?vue&type=script&lang=js&"
export * from "./SendOrderToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendOrderToolbar.vue"
export default component.exports